// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"f09bc82f","324":"4c2a2a37","746":"358ce53d","825":"0e3fc000"}[chunkId] + ".chunk.js";
};